import React from 'react'
import { Link } from 'react-router-dom'

import red from '../../img/Untitled design-red.png'
import white from '../../img/Untitled design-white.png'
import Spring from '../../img/Untitled design-spring.png'
export default function Onion() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd11 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Onion </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products</Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Onion </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Onion</h2>
        <h5 className='text-muted'> Onion is a type of root vegetable known for its strong smell and sharp taste. <br /><br />
          Onions come in several varieties, including white, red, yellow, and green.
        </h5>
      </div>


      <div className="container-fluid bg-light bg-icon mb-5 py-5">
    <div className="container">
        <div className="section-header text-center mx-auto my-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '500px' }}>
            <h1 className="display-5 text-primary">Types of Onions</h1>
            <p className='text-secondary'>We offer 3 Types of onions.</p>
        </div>
        <div className="row g-4" style={{ height: '400px' }}> {/* Increased height to accommodate images */}
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <div className="bg-white text-center h-100 p-xl-5">
                    <h3 className="text-primary fw-bolder mb-4">Red Onion</h3>
                    <img src={red} alt="Red Onion" style={{ width: '100%', height: '200px', objectFit: 'cover' }} /> {/* Add your image URL here */}
                </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                <div className="bg-white text-center h-100 p-xl-5">
                    <h3 className="text-secondary fw-bolder mb-4">White Onion</h3>
                    <img src={white } alt="White Onion" style={{ width: '100%', height: '200px', objectFit: 'cover' }} /> {/* Add your image URL here */}
                </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                <div className="bg-white text-center h-100 p-xl-5">
                    <h3 className="text-primary fw-bolder mb-4">Spring Onion</h3>
                    <img src={Spring} alt="Spring Onion" style={{ width: '100%', height: '200px', objectFit: 'cover' }} /> {/* Add your image URL here */}
                </div>
            </div>
        </div>
    </div>
</div>

     
 
        <h2 className='text-primary my-3'>Packing : Yellow and Red fresh onion</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>10/15/20/25/50 kg sacks

    </h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>10 kg and 25 kg – mesh bag
</h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>550 kg – wooden bins
</h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>    1250 kg – jumbo bag 
</h5>
  </li>
</ul>

<hr />
<h2 className='text-primary my-3'>Season:  Yellow and Red fresh onion</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Egypt, runs from March. to September 
    </h5>
  </li>


</ul>
<hr />
<hr />
<h2 className='text-primary my-3'>sizes: Yellow and Red fresh onion </h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- 40 up 
    </h5>
  </li>


</ul>

<hr />
<hr />
 
      <h2 className='text-primary my-3'>Packing : spring onion</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Short and long 


    </h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Length: As client request 

</h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Bulb Size 9-15 mm

</h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>   Weight is 125 grams

</h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>   Assembled 7-11 pieces


</h5>
  </li>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'> 14 punch per box

</h5>
  </li>
</ul>

<hr />
<h2 className='text-primary my-3'>Season: spring onion</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'> from October to mid of April

    </h5>
  </li>


</ul>
<hr />
<hr />
<h2 className='text-primary my-3'>sizes: spring onion </h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- Carton or plastic
    </h5>
  </li>


</ul>

      <hr />
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
